import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getSplashData } from '../../services/splashService';
import { loginUser, logoutUser } from '../auth/authActions';

export const fetchSplashData = createAsyncThunk(
    'splash/fetchData',
    async (_, { rejectWithValue }) => {
        try {
            const data = await getSplashData();
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const splashSlice = createSlice({
    name: 'splash',
    initialState: {
        data: null,
        loading: false,
        error: null,
        initialized: false
    },
    reducers: {
        resetSplash: (state) => {
            state.data = null;
            state.loading = false;
            state.error = null;
            state.initialized = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSplashData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSplashData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.initialized = true;
            })
            .addCase(fetchSplashData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.initialized = false;
            })
            // Reset splash data on logout
            .addCase(logoutUser.fulfilled, (state) => {
                state.data = null;
                state.initialized = false;
                state.error = null;
            });
    }
});

export const { resetSplash } = splashSlice.actions;
export default splashSlice.reducer; 